import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import CreaComentariosDirector from "./CreaComentariosDirector";

const ComentariosDirector = ({ solicitudId = 1055 }) => {
  const cookies = new Cookies();
  const [comentarios, setComentarios] = useState([]);
  const [loading, setLoading] = useState(false);

  const API_URL = `https://suadesarrollo.azurewebsites.net/api/ObtenerComentariosFicha/${solicitudId}`;

  const obtenerComentarios = async () => {
    setLoading(true);
    try {
      const response = await axios.get(API_URL, {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      });

      setComentarios(response.data || []);
    } catch (error) {
      console.error("Error al obtener comentarios:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    obtenerComentarios();
  }, [solicitudId]);

  // 🔥 AGREGA EL NUEVO COMENTARIO SIN RECARGAR
  const agregarComentario = (nuevoComentario) => {
    setComentarios((prev) => [nuevoComentario, ...prev]);
  };

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Comentarios del Director
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 6 ? (
            <CreaComentariosDirector
              idSolicitud={solicitudId}
              onComentarioCreado={agregarComentario}
            />
          ) : (
            <h></h>
          )}

          {loading ? (
            <p>Cargando comentarios...</p>
          ) : comentarios.length === 0 ? (
            <p>No hay comentarios disponibles</p>
          ) : (
            <div className="table-responsive">
              <table
                className="table table-bordered"
                width="100%"
                cellSpacing="0"
              >
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Usuario</th>
                    <th>Comentario</th>
                    <th>Fecha</th>
                  </tr>
                </thead>

                <tbody>
                  {comentarios.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.usuarioId}</td>
                      <td>{item.comentarios}</td>
                      <td>
                        {item.fecha
                          ? new Date(item.fecha).toLocaleString("es-CO")
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {cookies.get("tipo_Usuario") === 1 && (
            <div className="mt-3">
              <button
                className="btn btn-secondary"
                onClick={obtenerComentarios}
              >
                Recargar
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ComentariosDirector;
